/**
 *生产终端管理 接口
 */
 import axios from '../request';
 export default{
    /**
     * 钢筋笼信息打印
     */
    // 查询钢筋笼信息
    searchBearPrint: params =>
        axios.post('/materials/steelPrint/steelPrintList', params),
    // 添加钢筋笼信息
    insertBearPrint: params =>
        axios.post('/materials/steelPrint/steelPrintInsert', params),
    // 钢筋笼打印
    printBears: params =>
        axios.get('/materials/steelPrint/print', {params}),
    //查看钢筋笼打印列表
    seeBearPrintLists: params =>
        axios.post('/materials/steelProduce/steelProduceList', params),
    // 删除钢筋笼信息
    deleteBearPrint: params =>
        axios.get('/materials/steelPrint/steelPrintDel', {params}),
    //通过选择项目带回尺寸配筋等信息
    getTypePrints: params =>
        axios.post('/engineering/project/projectPull', params),

    /**
     * 管片信息打印
     */
    //今日/全部待出模查询列表(typeTime =1为当天其他数为全部)
    searchSegmentPrint: params =>
        axios.post('/materials/segmentPrint/printPlanList', params),
    //管片打印按钮
    segmentPrints: params =>
        axios.post('/materials/segmentPrint/printRecord', params),
    //已打印信息记录
    overSegmentPrints: params =>
        axios.post('/materials/segmentPrint/printRecordList', params),
    
    //生成二维码图片
    getPrintPhone: params =>
        axios({
            method: 'get',
            url: '/materials/steelPrint/test',
            responseType: 'blob',
            params: params
        }),
 }